// module_configs/superadmin.js
import React from 'react';
import { 
  faGaugeHigh, faGear, faBullhorn, faUsers, faFileInvoice, faCrown,
  faLayerGroup, faShop, faUsersCog, faCog, faCrown as faCrownIcon,
  faPeopleGroup
} from '@fortawesome/free-solid-svg-icons';

// Import Super Admin components
import DashboardHome from '.././module_superadmin/Dashboard/Dashboard_SuperAdmin';
import RootUsers from '.././module_roots/RootUsers';
import MessageSystem from '.././module_roots/MessageSystem';
import SubscriptionList from '.././module_roots/SubscriptionsHistory';
import Invoices from '.././module_roots/root_invoices';
import ShopsManagement from '.././module_roots/Shops';
import CentralizationManager from '.././module_roots/root_centeralization';
import InternshipForm from '.././module_fabrics/internshipcert';

export const superadminConfig = {
  moduleId: 'superadmin',
  moduleName: 'Super Admin',
  icon: faCrownIcon,
  description: 'Super Admin Control Panel',
  
  dashboardComponent: DashboardHome,
  
  roles: {
    'super_admin': { level: 0, label: 'Super Admin', color: '#ef4444' }
  },
  
  menuGroups: [
    { id: 'management', name: 'Management', icon: faUsersCog, order: 1 },
    { id: 'system', name: 'System', icon: faCog, order: 2 },
    { id: 'billing', name: 'Billing', icon: faFileInvoice, order: 3 },
    { id: 'centralization', name: 'Centralization', icon: faLayerGroup, order: 4 }
  ],
  
  menus: [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: faGaugeHigh,
      component: DashboardHome,
      roles: ['all'],
      groupId: 'management',
      position: 0
    },
    {
      id: 'shop',
      label: 'Create Shop',
      icon: faShop,
      roles: ['super_admin'],
      groupId: 'management',
      position: 1,
      submenus: [
        {
          id: 'shops',
          label: 'Create Shops',
          component: ShopsManagement,
          icon: faShop,
          roles: ['super_admin']
        }
      ]
    },
    {
      id: 'billing',
      label: 'Billings',
      icon: faFileInvoice,
      roles: ['super_admin'],
      groupId: 'billing',
      position: 2,
      submenus: [
        {
          id: 'managebillings',
          label: 'Manage Billings',
          component: SubscriptionList,
          icon: faCrown,
          roles: ['super_admin']
        },
        {
          id: 'manageinvoices',
          label: 'Manage Invoices',
          component: Invoices,
          icon: faCrown,
          roles: ['super_admin']
        }
      ]
    },
    {
      id: 'internship',
      label: 'Internship',
      icon: faUsers,
      roles: ['super_admin'],
      groupId: 'management',
      position: 3,
      submenus: [
        {
          id: 'form',
          label: 'Form',
          component: InternshipForm,
          icon: faUsers,
          roles: ['super_admin']
        }
      ]
    },
    {
      id: 'centralization',
      label: 'Centralization',
      icon: faLayerGroup,
      roles: ['super_admin'],
      groupId: 'centralization',
      position: 4,
      submenus: [
        {
          id: 'assigncentralization',
          label: 'Assign Centralization',
          component: CentralizationManager,
          icon: faPeopleGroup,
          roles: ['super_admin']
        }
      ]
    },
    {
      id: 'settings',
      label: 'Settings',
      icon: faGear,
      roles: ['super_admin'],
      groupId: 'system',
      position: 5,
      submenus: [
        {
          id: 'manageusers',
          label: 'Manage Users',
          component: RootUsers,
          icon: faUsers,
          roles: ['super_admin']
        }
      ]
    },
    {
      id: 'systemupdates',
      label: 'Notifications Center',
      icon: faBullhorn,
      component: MessageSystem,
      roles: ['super_admin'],
      groupId: 'system',
      position: 6,
      submenus: []
    }
  ],
  
  quickStats: [
    { id: 'totalUsers', label: 'Total Users', icon: 'faUsers', value: 156 },
    { id: 'totalShops', label: 'Total Shops', icon: 'faShop', value: 23 },
    { id: 'activeSubscriptions', label: 'Active Subscriptions', icon: 'faCrown', value: 18 },
    { id: 'totalRevenue', label: 'Total Revenue', icon: 'faMoneyBillWave', value: '$45,200' }
  ],
  
  shortcuts: [
    { key: 'Alt + D', description: 'Dashboard' },
    { key: 'Alt + U', description: 'Manage Users' },
    { key: 'Alt + S', description: 'Create Shop' },
    { key: 'Alt + B', description: 'Billings' },
    { key: 'Ctrl + R / Cmd + R', description: 'Refresh Dashboard Data' },
    { key: 'Alt + H', description: 'Toggle Shortcuts Panel' }
  ]
};